import React from "react";

// ASSETS
import FolderIcon from "assets/svg/Folder.svg";
import CerereLegea544 from "assets/pdf/CerereLegea544.pdf";
import ReclamatieLegea544 from "assets/pdf/ReclamatieLegea544.pdf";

// STYLES
import {
  BigContainer,
  Body,
  IconContainer,
  ParentContainer,
  SmallContainer,
  SmallContainersWrapper,
  Title,
  UnderlinedText,
} from "./LastTitlesStyled";

// LIBRARIES

import { useTranslation } from "react-i18next";

// MISC
import { TextType } from "components/Atoms/CustomText/CustomTextModel";
import { COLORS } from "constants/variables";
import { IProps } from "./LastTitlesModel";

// REDUX
import { useSelector } from "react-redux";
import { accessibilityBiggerCursorSelector } from "slices/UISlice/uiSliceSelectors";

// COMPONENTS
import CustomText from "components/Atoms/CustomText/CustomText";
import useWindowWidth from "hooks/useWindowWidth";

const LastTitles: React.FC<IProps> = () => {
  // PROPERTIES

  // LIBRARY CONSTANTS
  const biggerCursor = useSelector(accessibilityBiggerCursorSelector);
  const { t } = useTranslation();

  // STATE CONSTANTS
  const windowWidth = useWindowWidth();

  // API REQUESTS

  // LIFE CYCLE

  // EVENT HANDLERS
  const handleDownload = (filePath: string) => () => {
    const link = document.createElement("a");
    link.href = filePath;
    link.setAttribute("download", "");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <ParentContainer>
      <BigContainer>
        <Title>
          <CustomText
            type={TextType.H2}
            text={t("view.lastTitles.lastTitles")}
            color={COLORS.Yellow}
          />
        </Title>
        <Body>
          <CustomText
            type={TextType.P1}
            text={t("view.lastTitles.firstText")}
            color={COLORS.Cultured}
          />
          <UnderlinedText>
            <CustomText
              type={TextType.P1}
              text={t("view.lastTitles.secondText")}
              color={COLORS.Yellow}
            />
          </UnderlinedText>
        </Body>
      </BigContainer>
      <SmallContainersWrapper>
        <SmallContainer
          biggerCursor={biggerCursor}
          onClick={handleDownload(CerereLegea544)}
        >
          <CustomText
            type={windowWidth > 500 ? TextType.H4 : TextType.H5}
            text={t("view.lastTitles.firstForm")}
            color={COLORS.RaisinBlack}
          />
          <IconContainer src={FolderIcon} />
        </SmallContainer>
        <SmallContainer
          biggerCursor={biggerCursor}
          onClick={handleDownload(ReclamatieLegea544)}
        >
          <CustomText
            type={windowWidth > 500 ? TextType.H4 : TextType.H5}
            text={t("view.lastTitles.secondForm")}
            color={COLORS.RaisinBlack}
          />
          <IconContainer src={FolderIcon} />
        </SmallContainer>
      </SmallContainersWrapper>
    </ParentContainer>
  );
};

export default LastTitles;
